const tr = {
  reportsAsaas: {
    attributes: {
      payment_id: 'ID Transação',
      holder_name: 'Titular da conta',
      payer_name: 'Dono do Cartão',
      amount: 'Valor',
      billing_type: 'Método de pagamento',
      number_of_lifes: 'Número de Vidas',
      card_number: 'Número do Cartão',
      created_at: 'Criado em',
      approved_at: 'Aprovado em',
      payment_gateway: 'Fornecedor',
      status_message: 'Status do Pagamento',
      product: 'Produto',
      payment_origin: 'Origem',
      reports: 'Relatório Asaas',
      reports_description:
        'Relatório de vendas realizadas através das integrações com Asaas',
    },
    extras: {
      date_init: 'Data inicial',
      date_end: 'Data final',
      notUsedDaysAfter: 'Não utilizado dentro de 7 dias',
      notRenewedAfterAcquire: 'Não renovados pós-compra',
      onlyRenewed: 'Somente renovados',
    },
    defSingular: 'Relatório Asaas',
  },
};

export default tr;
